'use client'

import { Builder } from '@builder.io/react'

import { pillsNavDefaults } from '@src/components/PillsNav/PillsNav.defaults'

import { PillsNav } from './PillsNav'

Builder.registerComponent(PillsNav, {
  name: 'PillsNav',
  inputs: [
    {
      name: 'items',
      type: 'list',
      defaultValue: pillsNavDefaults.items,
      subFields: [
        {
          name: 'label',
          type: 'string',
          localized: true,
          defaultValue: pillsNavDefaults.items[0].label,
        },
        {
          name: 'href',
          type: 'string',
          localized: true,
          defaultValue: pillsNavDefaults.items[0].href,
        },
        {
          name: 'isVisible',
          type: 'boolean',
          defaultValue: true,
          localized: true,
        },
      ],
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/layout-navbar.svg',
})
